import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/utils/api";

export const fetchNewShuttleLess = createAsyncThunk(
  "newShuttleLess/fetchNewShuttleLess",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/new_shuttleless/${id}`);
      return response?.data?.data || {};
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch form Data"
      );
    }
  }
);

export const fetchNewShuttleLessAvailable = createAsyncThunk(
  "newShuttleLess/fetchNewShuttleLessAvailable",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/new_shuttleless_available_limit`);
      return response?.data?.data || {};
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch modernization"
      );
    }
  }
);

const initialState = {
  data: {},
  current_tab: "personal",
  available_limit: {},
  data_loading: false,
  user_initiated_nav: false,
  error: null,
};

const newLoomSlice = createSlice({
  name: "newLoom",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = {
        ...(state.data || {}),
        ...(action.payload || {}),
      };
    },
    clearError: (state) => {
      state.error = null;
    },
    setCurrentTab: (state, action) => {
      state.current_tab = action.payload;
    },
    setDataLoading: (state, action) => {
      state.data_loading = action.payload;
    },
    setUserInitiatedNav: (state, action) => {
      state.user_initiated_nav = action.payload;
    },
    resetNewLoomSliceState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNewShuttleLess.pending, (state) => {
        state.data_loading = true;
        state.error = null;
      })
      .addCase(fetchNewShuttleLess.fulfilled, (state, action) => {
        state.data_loading = false;
        state.data = action.payload || {};
      })
      .addCase(fetchNewShuttleLess.rejected, (state, action) => {
        state.data_loading = false;
        state.error = action.payload;
      })
      .addCase(fetchNewShuttleLessAvailable.pending, (state) => {
        state.data_loading = true;
        state.error = null;
      })
      .addCase(fetchNewShuttleLessAvailable.fulfilled, (state, action) => {
        state.data_loading = false;
        state.available_limit = action.payload || {};
      })
      .addCase(fetchNewShuttleLessAvailable.rejected, (state, action) => {
        state.data_loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setData,
  setCurrentTab,
  setDataLoading,
  clearError,
  resetNewLoomSliceState,
  setUserInitiatedNav,
} = newLoomSlice.actions;
export default newLoomSlice.reducer;
